import { useState } from 'react'

import SafeJSON from 'modules/core/lib/SafeJSON'
import SafeLocalStorage from 'modules/core/lib/SafeLocalStorage'

type UpdaterFn<T> = (prevValue: T | null) => T | null
type SetValueParam<T> = T | UpdaterFn<T> | null

export default function useLocalStorage<T = unknown>(
  localStorageKey: string,
  defaultValue?: T
): [T | null, (value: SetValueParam<T>) => void] {
  const persistedValue = SafeJSON.parse<T | null>(
    SafeLocalStorage.getItem(localStorageKey, null),
    null
  )

  const [value, setValue] = useState<T | null>(persistedValue ?? defaultValue ?? null)

  const setPersistedValue = (newValue: SetValueParam<T>) => {
    const valueToStore = newValue instanceof Function ? newValue(value) : newValue
    SafeLocalStorage.setItem(localStorageKey, JSON.stringify(valueToStore))
    setValue(valueToStore)
  }

  return [value, setPersistedValue]
}
